/**
 * ============================================================
 * AdminLogin.js — Admin Login Page
 * ============================================================
 *
 * Handles:
 *   - Username/password login for admin dashboard
 *   - Sends POST request to /api/admin
 *   - Stores JWT token in localStorage for authenticated routes
 *   - Redirects to /admin/users on success
 *
 * Notes:
 *   - Backend expects: { username, password }
 *   - No separate "auth" flag is needed; token alone indicates login
 **/

import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import "./css/AdminLogin.css";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function AdminLogin() {

  // ----------------------------------------------------------
  // State: username & password inputs
  // ----------------------------------------------------------
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // React Router navigation helper
  const navigate = useNavigate();


  // ----------------------------------------------------------
  // Submit Handler — Sends login request to backend
  // ----------------------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/admin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      // Handle invalid credentials (401 / 403 responses)
      if (!res.ok) {
        alert("Invalid credentials");
        return;
      }

      const data = await res.json();

      // Store token and redirect on success
      if (data.token) {
        localStorage.setItem("token", data.token);
        navigate("/admin/dashboard");   // Admin dashboard entry page
      } else {
        alert("Invalid credentials");
      }

    } catch (err) {
      console.error("Login error:", err);
      alert("Login failed — server error");
    }
  };


  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <div className="admin-login-wrapper">

      {/* ----- LOGIN BOX ----- */}
      <div className="admin-login-box">

        {/* ----- LOGO - links to public facing homepage ----- */}
        <Link to="/">
          <img
            src="/logos/synlab-logo.png"
            alt="Synlab Home"
            className="admin-login-logo"
          />
        </Link>

        {/* ----- PAGE TITLE ----- */}
        <h1 className="admin-login-title">Synlab Admin Login</h1>

        {/* ----- LOGIN FORM ----- */}
        <Form onSubmit={handleSubmit} className="admin-login-form">

          {/* ----- USERNAME FIELD ----- */}
          <Form.Group controlId="formBasicUsername">
            <Form.Label className="mt-3">Username</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>

          {/* ----- PASSWORD FIELD ----- */}
          <Form.Group controlId="formBasicPassword">
            <Form.Label className="mt-3">Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>

          {/* ----- Submit Button ----- */}
          <Button
            variant="primary"
            type="submit"
            className="w-100 mt-4"
          >
            Login
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default AdminLogin;